import { ActivityTimeCost, toActivityTimeCost } from '@faro/study-designer-model';
import axios from 'axios';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { ScheduleOfActivitiesQueryParameter, StudyPathParameter, VariantQueryParameter } from '../parameter';

const ActivityTimeCostType = 'ActivityTimeCost';

const factory = createStudyEntityHookFactory<ActivityTimeCost>(ActivityTimeCostType);

export type ActivityTimeCostPathParameters = StudyPathParameter;
export type ActivityTimeCostQueryParameters = ScheduleOfActivitiesQueryParameter & VariantQueryParameter;

export const useActivityTimeCosts = factory.list(
    (
        { studyId, ...query }: ActivityTimeCostPathParameters & ActivityTimeCostQueryParameters,
        signal?: AbortSignal
    ): Promise<ActivityTimeCost[]> =>
        axios
            .get(`/api/study-designer/studies/${studyId}/activity-time-costs`, { params: query, signal })
            .then(response => response.data?.map(toActivityTimeCost) ?? [])
);
